import { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from '../../util/constants';

export const useStripePromise = () => useMemo(() => loadStripe(STRIPE_PUBLIC_KEY), []);
